<template>
  <v-row>
    <!-- Menú lateral -->
    <v-col cols="3">
      <v-card class="menu-card rounded-lg">
        <v-list dense>
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            :class="{ 'menu-item-selected': selectedItem === index }"
            @click="selectComponent(index)"
          >
            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>

    <!-- Área del componente seleccionado -->
    <v-col cols="9">
      <v-card class="rounded-lg">
        <component :is="selectedComponent" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import RawMaterial from "@/components/quality/RawMaterial.vue";
export default {
  components: {
    RawMaterial,
  },
  data() {
    return {
      menuItems: [{ label: "Materia prima", component: RawMaterial }],
      selectedItem: null,
      selectedComponent: null,
    };
  },
  methods: {
    selectComponent(index) {
      this.selectedItem = index;
      this.selectedComponent = this.menuItems[index].component;
    },
  },
  mounted() {
    this.selectedItem = 0;
    this.selectedComponent = this.menuItems[0].component;
  },
};
</script>

<style scoped>
.menu-card {
  height: 100%; /* Hace que la tarjeta del menú ocupe todo el espacio vertical */
}

.menu-item-selected {
  background-color: #cef5bf;
  animation: bounce 0.3s;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-5px);
  }
  60% {
    transform: translateY(-3px);
  }
}
</style>
